import { AfterViewInit, Component, DoCheck, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { AppState } from '../app.service';
import { CordovaService } from '../cordova.service';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path-v2.model';
import { User } from '../user/user.model';
import { RoutineInfo } from './routine-info.model';
import { HomeUiService } from '../new-design/home-ui.service';
import { RoutineV2Service } from './routine-v2.service';
import { I18n } from '../i18n.service';
import { ToasterService } from '../toaster.service';
import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { KyperDataApiService } from '../services/kyper-data-api.service';
import { ModalController } from '@ionic/angular';
import { HabitDescriptionModalComponent } from '../new-design/habit-description-modal/habit-description-modal.component';
// import { IonItem, IonList, IonToggle } from '@ionic/angular';

@Component({
  selector: 'first90-routine-v2',
  templateUrl: './routine-v2.component.html',
  styleUrls: ['./routine-v2.component.scss'],
  // animations: [
  //   trigger('fadeInOut', [
  //     state('in', style({ opacity: 1, height: 'auto' })),
  //     transition(':enter', [
  //       style({ opacity: 0, height: 0 }),
  //       animate('0.25s linear', style({ opacity: 1, height: '50px' }))
  //     ]),
  //     transition(':leave', [
  //       animate('0.25s linear', style({ opacity: 0, height: 0 }))
  //     ])
  //   ]),
  // ]

   animations: [
    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),

        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),

      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ]
})
export class RoutineV2Component implements OnInit, DoCheck, OnDestroy,AfterViewInit {

  @Input() routine
  @Input() isTitleScreen: boolean
  @Input() todoRoutines;
  @Input() isSubLevelScreen: boolean
  @Input() isImInCompleted: any
  @Input() inverted = false
  @Input() currentDay;
  @Input() currentOpenedChapterIndex;
  finalizedLevelIds = [];
  selectedLevels = []
  unCheckedLevels = []
  imInCompleted: boolean
  islevelUpdated: boolean
  flag=false;
  dragOccurred = false;
  isLoaded=true;
  isInitialLoad: boolean = true;
  animatingLevelIds: Set<number> = new Set();
  isTransitioning: boolean = false;
  exitingLevelId: number | null = null;
  unCheckedRoutineLevels;
  currentPath: Path;
  routineData;
  currentUser: User;
  comitRoutine;
  // isReorderDisabled = false;
  isReorderDisabled: boolean[] = [];
  checkedRoutineLevels: any[] = [];
  deactivepaddingtop: boolean = false;
  activepaddingbottom: boolean = false;
  activestepIndex;
  private _prevSnapshot: string = '';
  @ViewChildren('toggleIndex', { read: ElementRef }) toggleIndexEls: QueryList<ElementRef>;
  constructor(private cordovaService: CordovaService,
    private appState: AppState,
    private routineV2Service: RoutineV2Service,
    private i18n: I18n,
    private tostrService: ToasterService,
    public homeUIService: HomeUiService,
    private kyperDataService: KyperDataApiService,
    private homeService: HomeV5Service,
    private modalCtrl: ModalController)
     {
      this.currentPath = this.appState.get('currentPath');
    this.currentUser = this.appState.get('currentUser')
      this.activestepIndex = this.appState.get('currentActiveStepIndex');
      this.checkIsLevelsShuffled();
    }
  ngAfterViewInit(): void {
      this.syncToggleNumbers();
      setTimeout(() => { this.isInitialLoad = false; }, 950);
   }

   checkIsLevelsShuffled() {
      const requestData = {
      'path_id': this.currentPath.id
    }
     this.kyperDataService.getHabitsList(requestData).subscribe(
        (response) => {
         let editRoutineList = this.homeService.removeDuplicates(response.habits, "habitGroupId");
         let dailyStepsArray = this.appState.get("DailyStepsData");
         let currentDayRoutine = dailyStepsArray[this.currentOpenedChapterIndex]?.steps[this.activestepIndex]
         let routine = this.currentPath.filterStepsByContentType('habits', currentDayRoutine)?.[0]?.screen;
         let routineInfo =routine?.content
         let updated_routine = []
          editRoutineList?.forEach((optRoutine) => {
            if (!Array.isArray(optRoutine?.selectedHabitIds)) {
              optRoutine.selectedHabitIds = [];
            }
            // routineInfo?.habits?.forEach((routine) => {
            //  updated_routine =[]
            // if (optRoutine?.habitGroupId == routine?.id && optRoutine?.habitGroupId== currentDayRoutine?.id) {
              if (optRoutine?.selectedHabitIds?.length != routineInfo?.habits?.length && optRoutine?.habitGroupId == routine?.id) {
               routineInfo?.habits?.forEach((level) => {
                  let matchedLevel = optRoutine?.habits?.filter((optLevel) => optLevel.level == level.level && optRoutine?.selectedHabitIds?.includes(optLevel.id))
                  let unMatchLevelIndex = optRoutine?.habits?.findIndex((optLevel) => optLevel?.id==level.id && optRoutine?.selectedHabitIds?.includes(level.id))
                  if (matchedLevel?.length == 0) {
                    let levelId = this.appState.get('unCheckedLevelId');
                    let levelNumber = this.appState.get('LevelNumber');
                    let isUnCheckedLevelUnlocking;
                    if (levelId) {
                      isUnCheckedLevelUnlocking = level.id == levelId && level.level == levelNumber;
                    }
                    if (isUnCheckedLevelUnlocking) {
                      level.enabled = true
                      updated_routine = optRoutine?.habits
                      //updated_routine?.sort((a, b) => a?.level - b?.level);
                      let originalIndex =  this.routine.habits.findIndex(item => item.id === level.id);
                      this.routine.habits[originalIndex].enabled = true
                    }
                    else {
                      level.enabled = false
                      updated_routine = optRoutine?.routine
                      //updated_routine?.sort((a, b) => a?.level - b?.level);
                      let originalIndex =  this.routine.habits.findIndex(item => item.id === level.id);
                       this.routine.habits[originalIndex].enabled = false
                      let index =  this.routineData.habits.findIndex(item => item.id === level.id)
                      // this.routineData.levels[index].enabled = false
                    }
                  }
                  else {
                     updated_routine = optRoutine?.habits
                    let changedLevel = level
                    changedLevel.enabled = optRoutine?.selectedHabitIds?.includes(optRoutine?.habits[unMatchLevelIndex]?.id) 
                    let originalIndex =  this.routine.habits.findIndex(item => item.id === changedLevel.id);
                     this.routine.habits[originalIndex].enabled = optRoutine.selectedHabitIds?.includes(optRoutine?.habits[unMatchLevelIndex]?.id) ;
                    let index = this.routineData?.habits?.findIndex(item => item.id === changedLevel.id)
                    //this.routineData.levels[index].enabled =optRoutine[unMatchLevel]?.level?.enabled;
                  }
                
                })

                this.routine.habits = [...new Set(this.routine.habits)]
                let levelsOrder = []
                if (optRoutine?.selectedHabitIds?.length == 0 && (optRoutine?.selectedHabitIds?.length != optRoutine?.habits?.length)) {
                  optRoutine?.habits?.forEach((level, index) => {
                    levelsOrder.push({ id: level?.id, index: index })
                  })

                }
                else {
                  levelsOrder = optRoutine?.selectedHabitIds?.map((id, index) => ({
                    id,
                    index
                  }));
                }
                levelsOrder =[...new Set(levelsOrder)]
                this.routine.habits= this.sortArrayByReference(levelsOrder,  this.routine.habits);
                this.shuffleOrderOfLevels();
              }
            // }
          // })
                   
          })   

        },
        (error) => {
          console.log('Error for routines ', error)
          this.tostrService.error(this.i18n.t('No record found'))
       })

   }
   sortArrayByReference(arr1: any[], arr2: any[]): any[] {
    const indexMap = new Map(arr1.map((item, index) => [item.id, index]));
    return arr2.sort((a, b) => {
        const indexA = indexMap.get(a.id) ?? Number.MAX_VALUE;
        const indexB = indexMap.get(b.id) ?? Number.MAX_VALUE;
        return indexA - indexB;
    });
}
    getRoutines() {
     this.todoRoutines?.forEach((routine)=>{
      if(routine.habitGroupId ==this.routineData?.screenContentId) {
          this.comitRoutine =routine;
      }
     })
     if(this.comitRoutine?.selectedHabitIds?.length != this.routineData?.habits?.length) {

     
     this.comitRoutine?.habits.forEach((level)=>{
      this.routineData?.habits?.forEach((routineLevel)=>{
        let status =false;
        this.comitRoutine?.habits.forEach((level)=>{
          if(level.id==routineLevel.id){
             status =true
          }
        })
        if(level.id == routineLevel.id || status) {
          routineLevel.enabled =true;
          this.isLoaded=false;
        }
        else {
          routineLevel.enabled =false;
          this.isLoaded=false;

        }
      })
     })
    }
      if(!this.isLoaded) {
        this.isLoaded =true;
      }
    }
   UncheckedLevelsStatus(subLevel) {
    this.unCheckedRoutineLevels =[];
    this.routineData?.habits?.forEach((routineLevel)=>{
       this.unCheckedLevels.forEach((level)=>{
       if (routineLevel?.id == subLevel?.id) {
         routineLevel.enabled = false;
           let originalIndex =  this.routine?.habits.findIndex(item => item.id === routineLevel.id);
            this.routine?.habits?.splice(originalIndex,1);
            this.routine.habits = [routineLevel,...this.routine?.habits];
            this.routine.habits= [...new Set(this.routine?.habits)]
         this.unCheckedRoutineLevels= [routineLevel, ...this.unCheckedRoutineLevels]
          this.unCheckedRoutineLevels =[...new Set(this.unCheckedRoutineLevels)]
        }
       else {
         if (routineLevel?.id == level?.id) {
           routineLevel.enabled = false;
           let originalIndex = this.routine?.habits?.findIndex(item => item.id === level.id);
           this.routine.habits[originalIndex].enabled = false;
           this.routine.habits = [...new Set(this.routine?.habits)]
          this.unCheckedRoutineLevels .push(routineLevel)
          this.unCheckedRoutineLevels = [...new Set(this.unCheckedRoutineLevels)]
         }
       }
       })
              })
  
     this.routine.habits = [...new Set(this.routine?.habits)]
     this.shuffleOrderOfLevels();
   }
  
  shuffleOrderOfLevels() {
    const enabledArray = this.routine?.habits.filter(item => item.enabled || item.enabled==undefined);
    const disabledArray = this.routine?.habits.filter(item => item.enabled==false);
    this.routine.habits = [...enabledArray, ...disabledArray];
    this.setData();
    //this.syncToggleNumbers();
  }

    findForCurrentDay(collection: any): any {
      return collection.find(
        item => item.startDay <= this.currentDay && this.currentDay <= item.endDay
      )
    }
  
  ngOnInit() {
    
    if(this.appState.get("isLoggedIn")) {
      this.isLoaded =false;
    }
     this.unCheckedLevels =this.appState.get('unCheckedLevels');
     this.unCheckedLevels = this.homeService.removeDuplicates(this.unCheckedLevels, "id");
     this.unCheckedLevels=[...new Set(this.unCheckedLevels)];
     if(this.unCheckedLevels ==undefined || this.unCheckedLevels ==null) {
      this.unCheckedLevels =[];
     }
     this.selectedLevels =this.appState.get('selectedLevelIds');
     this.selectedLevels = this.homeService.removeDuplicates(this.selectedLevels, "id");
     this.selectedLevels=[...new Set(this.selectedLevels)];
     if(this.selectedLevels ==undefined || this.selectedLevels ==null) {
      this.selectedLevels =[];
     }
  }

  ngOnChanges() {
    this.unCheckedLevels =this.appState.get('unCheckedLevels');
    this.unCheckedLevels = this.homeService.removeDuplicates(this.unCheckedLevels, "id");
    this.unCheckedLevels=[...new Set(this.unCheckedLevels)];

    this.selectedLevels =this.appState.get('selectedLevelIds');
    this.selectedLevels = this.homeService.removeDuplicates(this.selectedLevels, "id");
    this.selectedLevels=[...new Set(this.selectedLevels)];
   
  }
  ngDoCheck() {
    // Early bail-out: skip all work if nothing relevant has changed.
    // ngDoCheck fires on every CD cycle (dozens/sec on mobile) — without this guard,
    // removeDuplicates + appState.set run constantly, burning the JS thread so the
    // first toggle tap after all-deselected feels frozen.
    const snapshot = JSON.stringify({
      habits: this.routine?.habits?.map((h: any) => ({ id: h.id, enabled: h.enabled })),
      isLoggedIn: this.appState.get("isLoggedIn"),
      levelUpdated: this.appState.get('levelUpdated'),
      isTransitioning: this.isTransitioning,
    });
    if (snapshot === this._prevSnapshot) return;
    this._prevSnapshot = snapshot;

    let dailyStepsArray= this.appState.get("DailyStepsData");
    this.activestepIndex = this.appState.get('reviewingStepIndex');
    let currentDayRoutine =dailyStepsArray[this.currentOpenedChapterIndex]?.steps[this.activestepIndex]
    this.routineData =this.currentPath?.filterStepsByContentType('habits',currentDayRoutine)?.[0]?.screen?.content
    // this.routineData = dailyStepsArray[this.currentDay-1].routineInfo
    this.islevelUpdated = this.appState.get('levelUpdated')
    if(this.islevelUpdated) {
      this.appState.set("isLoggedIn", undefined);
      this.isLoaded =true;
    }
    if(this.appState.get("isLoggedIn"))  {
      this.getRoutines();
    }
    
    if(this.islevelUpdated) {
      this.appState.set("isLoggedIn", undefined);
      this.isLoaded =true;
      this.routine?.habits.forEach((level)=>{
        if(level.enabled ==false) {
          let originalIndex =  this.routine?.habits.findIndex(item => item.id === level.id);
          //this.routine?.habits.splice(originalIndex,1);
          level.enabled = false;
          this.routine.habits= [...new Set(this.routine?.habits)];

        }
      })
      this.routine.habits = [...new Set(this.routine?.habits)];
      const indexMap = new Map(this.selectedLevels?.map(item => [item.id, item.index]));
      this.routine?.habits.sort((a, b) => {
        const indexA = indexMap.has(a.id) ? indexMap.get(a.id) : Infinity;
        const indexB = indexMap.has(b.id) ? indexMap.get(b.id) : Infinity;
        return indexA - indexB;
      })
      //this.shuffleOrderOfLevels();
     //this.routine?.habits= this.routine?.habits?.sort((a, b) => this.selectedLevels.indexOf(a.id) - this.selectedLevels.indexOf(b.id));
     // this.routine?.habits.sort((a,b)=>a.id-b.id);
    }
   
    // else {
    //   setTimeout(() => {
    //     this.UncheckedLevelsStatus();
    //   },300)
      
    // }
    if(this.selectedLevels && this.selectedLevels.length>0) {
      this.routine?.habits.forEach((element)=>{
        if(element.id=== this.selectedLevels[0].id)
        {
          this.flag =true;
        }
      })
    if(!this.flag) {
      this.unCheckedLevels =[]
      this.setData();
    }
    if(this.unCheckedLevels && this.unCheckedLevels.length>0){
      this.routine?.habits.forEach(element => {
         this.unCheckedLevels.forEach((level)=>{
          if(level.id !==element.id && !(this.unCheckedLevels.filter((level)=>level.id ==element.id)))
          {
              this.selectedLevels.push({'id':element.id, 'index':this.routine?.habits.indexOf(element)})
              this.selectedLevels=[...new Set(this.selectedLevels)];

          }
         })
        
      });
    }
    else {
      this.selectedLevels =this.appState.get('selectedLevelIds')
      this.routineData?.habits?.forEach(element => {
        if(element.enabled ==false) {
          this.unCheckedLevels.push({'id':element.id, 'index':this.routine?.habits.indexOf(element)})
          this.unCheckedLevels = this.homeService.removeDuplicates(this.unCheckedLevels, "index");
          this.unCheckedLevels=[...new Set(this.unCheckedLevels)];
          this.appState.set('unCheckedLevels', this.unCheckedLevels)
        }
      });
    }
  }
    else if(this.unCheckedLevels===undefined || this.unCheckedLevels==null || (this.unCheckedLevels && this.unCheckedLevels.length==0)){
      this.selectedLevels =this.appState.get('selectedLevelIds');
      // Guard: don't call setData() mid-transition — selectedLevels is temporarily empty
      // during the 300ms animation window after all habits are deselected, and setData()
      // resets state while AppendLevelsToRoutine is still running inside the timeout.
      if(!this.isTransitioning && ((this.selectedLevels && this.selectedLevels.length==0) || this.selectedLevels ==undefined || this.selectedLevels ==null)) {
       this.setData();
      }
    }
    else if(!this.isTransitioning && ((this.selectedLevels && this.selectedLevels.length==0) || this.selectedLevels ==undefined || this.selectedLevels ==null)) {
      this.setData();
     }
    this.selectedLevels = this.homeService.removeDuplicates(this.selectedLevels, "index");
    this.selectedLevels=[...new Set(this.selectedLevels)];
    this.appState.set('selectedLevelIds', this.selectedLevels)
    this.unCheckedLevels = this.homeService.removeDuplicates(this.unCheckedLevels, "index");
    this.unCheckedLevels=[...new Set(this.unCheckedLevels)];
    this.appState.set('unCheckedLevels', this.unCheckedLevels)
    this.imInCompleted = this.appState.get('isImInCompleted')
    // Always update rendered lists in ngDoCheck — the direct updates inside getCheckedIds
    // timeout handle the transition case; removing the isTransitioning guard here eliminates
    // the freeze where lists were locked for the full 300ms on mobile.
    this.checkedRoutineLevels = this.routine?.habits?.filter((level: any) => (level?.enabled== true||level?.enabled==undefined))
    this.unCheckedRoutineLevels = this.routine?.habits?.filter((level: any) => level?.enabled == false)
    //this.saveUpdatedOrder();
     // this.checkedRoutineLevels = checkedRoutineLevels.sort((a, b) => this.selectedLevels.indexOf(a.id) - this.selectedLevels.indexOf(b.id));
      //this.unCheckedRoutineLevels =unCheckedRoutineLevels.sort((a, b) => this.unCheckedLevels.indexOf(a.id) - this.unCheckedLevels.indexOf(b.id));
    
  }

  setData() {
    this.selectedLevels =[]
    this.routine?.habits.forEach(element => {
     if(element.enabled ==true || (element.enabled==undefined  )) {
      this.selectedLevels.push({'id':element.id, 'index':this.routine?.habits.indexOf(element)})
      this.selectedLevels = this.homeService.removeDuplicates(this.selectedLevels, "id");
      this.selectedLevels=[...new Set(this.selectedLevels)];
      this.appState.set('selectedLevelIds', this.selectedLevels)
     }  
     else {
      this.unCheckedLevels.push({'id':element.id, 'index':this.routine?.habits.indexOf(element)})
      this.unCheckedLevels = this.homeService.removeDuplicates(this.unCheckedLevels, "id");
      this.unCheckedLevels=[...new Set(this.unCheckedLevels)];
      this.appState.set('unCheckedLevels', this.unCheckedLevels)
     }
    });
     this.syncToggleNumbers();
  }
  getCheckedIds($event,level, index){
    let isChecked = $event.detail.checked;

    this.appState.set('isLevelsReshuffled',true);

    // Lock display lists so exit animation plays while item is still in its current list
    this.isTransitioning = true;
    this.exitingLevelId = level.id;

    if (isChecked === false) {
      // active → inactive: 300ms delay lets the exit animation play before DOM move
       this.isReorderDisabled[index] = true;
      this.appState.set("isLoggedIn", undefined);
      setTimeout(() => {
        level.enabled = false;
        this.unCheckedLevels.push({'id':level.id, 'index':this.routine?.habits.indexOf(level)});
        let originalIndex = this.selectedLevels.findIndex(item => item.id === level.id);
        this.selectedLevels.splice(originalIndex, 1);
        this.exitingLevelId = null;
        this.isTransitioning = false;
        this.UncheckedLevelsStatus(level);
        this.isReorderDisabled[index] = false;
        this.deactivepaddingtop = false;
        // Update rendered lists directly — don't wait for ngDoCheck to avoid mobile jank
        this.checkedRoutineLevels = this.routine?.habits?.filter((l: any) => l?.enabled === true || l?.enabled === undefined);
        this.unCheckedRoutineLevels = this.routine?.habits?.filter((l: any) => l?.enabled === false);
        this.animatingLevelIds.add(level.id);
        this.syncToggleNumbers();
        setTimeout(() => { this.animatingLevelIds.delete(level.id); }, 420);
      }, 300);

    } else if(isChecked === true) {
      // inactive → active: 300ms delay for toggle state to visually settle before DOM move
      this.isReorderDisabled[index] = true;
      this.appState.set("isLoggedIn", undefined);
      setTimeout(() => {
        level.enabled = true;
        this.selectedLevels.push({'id':level.id, 'index':this.routine?.habits.indexOf(level) >= 0 ? this.selectedLevels?.length + 1 : this.routineData?.habits?.indexOf(level) });
        this.unCheckedLevels = [...new Set(this.unCheckedLevels)];
        let originalIndex = this.unCheckedLevels.findIndex(item => item.id === level.id);
        this.unCheckedLevels.splice(originalIndex, 1);
        this.exitingLevelId = null;
        this.isTransitioning = false;
        this.AppendLevelsToRoutine(level);
        this.isReorderDisabled[index] = false;
        this.activepaddingbottom = false;
        // Update rendered lists directly — don't wait for ngDoCheck to avoid mobile jank
        this.checkedRoutineLevels = this.routine?.habits?.filter((l: any) => l?.enabled === true || l?.enabled === undefined);
        this.unCheckedRoutineLevels = this.routine?.habits?.filter((l: any) => l?.enabled === false);
        this.animatingLevelIds.add(level.id);
        this.syncToggleNumbers();
        setTimeout(() => { this.animatingLevelIds.delete(level.id); }, 420);
      }, 300);
    }

    if (this.selectedLevels) {
      this.selectedLevels = this.homeService.removeDuplicates(this.selectedLevels, "id");
      this.appState.set('selectedLevelIds', this.selectedLevels);
      this.appState.set('indexOfLevel', this.selectedLevels.length > 0 ? 0 : undefined);
    }

    if (this.unCheckedLevels) {
      let unCheckedLevels = this.homeService.removeDuplicates(this.unCheckedLevels, "id");
      unCheckedLevels = [...new Set(unCheckedLevels)];
      this.unCheckedLevels = unCheckedLevels;
      this.appState.set('unCheckedLevels', unCheckedLevels);
    } else {
      this.unCheckedLevels = [];
      this.appState.set('unCheckedLevels', undefined);
    }
  }

  AppendLevelsToRoutine(sublevel) {
    if(this.selectedLevels){
      function getUnique(arr) {
        const unique = arr.filter((id,index)=>{
          return arr.indexOf(id)===index
        })
        return unique;
      }

      let finalCheckedLevels = []
      finalCheckedLevels = getUnique(this.selectedLevels) 
      finalCheckedLevels =[...new Set(finalCheckedLevels)];
      // finalCheckedLevels.forEach(checkedLevel => {
        // this.routine?.habits.forEach(routineLevel => {
        //   if ( sublevel.id != routineLevel.id) {
            this.routineData?.habits?.forEach((level)=>{
              if(sublevel.id== level.id) {
               level.enabled=true;
               let originalIndex =  this.routine?.habits.findIndex(item => item.id === level.id);
                this.routine?.habits.splice(originalIndex,1);
                this.routine?.habits.push(level);
                this.routine.habits= [...new Set(this.routine?.habits)]
               // this.routine?.habits.sort((a,b)=>a.id-b.id);
              

              }
            });
            this.routine.habits =[... new Set(this.routine?.habits)]
         // }
        // });
      // })
      this.shuffleOrderOfLevels();
      this.selectedLevels = []
      this.unCheckedLevels =[]
      this.routine?.habits.forEach((level)=>{
        if(level.enabled || level.enabled==undefined) {
          this.selectedLevels.push({'id':level.id, 'index':this.routine?.habits.indexOf(level)})
          this.selectedLevels=[...new Set(this.selectedLevels)];
        }
        else {
          this.unCheckedLevels.push({'id':level.id, 'index':this.routine?.habits.indexOf(level)})
          this.unCheckedLevels=[...new Set(this.unCheckedLevels)];
        }
      })
      this.selectedLevels = this.homeService.removeDuplicates(this.selectedLevels, "id");
      this.unCheckedLevels = this.homeService.removeDuplicates(this.unCheckedLevels, "id");
      this.appState.set('unCheckedLevels', this.unCheckedLevels)
      this.appState.set('selectedLevelIds', this.selectedLevels)
    }
  }
 ngOnDestroy() {
  this.appState.set("isLoggedIn", undefined);

 }

  handleReorder(event) {
    console.log("eventt", event);
    this.dragOccurred = true;
    let len = this.unCheckedRoutineLevels?.length;
    const itemMove = this.routine?.habits.splice(event.detail.from, 1)[0];
    this.routine?.habits.splice(event.detail.to, 0, itemMove);
    this.appState.set('isLevelsReshuffled',true)
    this.setData();
    this.saveUpdatedOrder();
    event.detail.complete(this.checkedRoutineLevels);
    setTimeout(() => { this.dragOccurred = false; }, 300);
  }

  async openHabitDescription(event: Event, level: any, isDraggable: boolean = false) {
    event.stopPropagation();
    if (isDraggable && this.dragOccurred) {
      return;
    }
    const isMobile = this.appState.get('isMobile');
    const modal = await this.modalCtrl.create({
      component: HabitDescriptionModalComponent,
      componentProps: { habitLevel: level },
      animated: false,
      cssClass: isMobile ? 'custom-chapter-steps-modal-size' : 'web-action-calender-modal web-chapter-step-modal',
    });
    await modal.present();
  }

  syncToggleNumbers() {
    // requestAnimationFrame waits for the next paint when the DOM is actually updated,
    // more reliable than setTimeout(10) on slow mobile threads
    requestAnimationFrame(() => {
      this.toggleIndexEls?.forEach((el, idx) => {
        el.nativeElement.innerText = idx + 1;
      });
    });
  }
  saveUpdatedOrder() {  
   let idsArray = []
    this.routine?.habits.forEach(element => {
      if (element.enabled || element.enabled==undefined) {
        idsArray.push(element)
      }
    });

    this.finalizedLevelIds = idsArray.map(item => item.id)
    console.log("finialized reorder ids", this.finalizedLevelIds);
    console.log('New order saved');
  }

}